module.exports = __webpack_public_path__ + "static/media/administration_clients.0b06baaa.svg";